import { CONTRACT_CHANGE_VALIDATION_LIST } from '../ContractQueries'
import { ApolloError, useQuery } from '@apollo/client'
import { ContractChangeValidationListQuery, ContractChangeValidationListQueryVariables, Country } from '../../../types'

export default (
  employeeId: number,
  country: Country,
): { data: ContractChangeValidationListQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const variables = {
    employeeId: employeeId,
    country: country,
  }
  const { data, error, loading } = useQuery<ContractChangeValidationListQuery, ContractChangeValidationListQueryVariables>(
    CONTRACT_CHANGE_VALIDATION_LIST,
    {
      variables: variables,
    },
  )

  return { data, error, loading }
}
